import type { LoggerService } from '@/services/abstract/LoggerService';
import type { MessageHandlerResult } from '@/services/abstract/poc/MessagingService';
import type { HeliaNode } from '@/types/poc/helia';
import type { LibP2pWithServices } from '@/types/poc/libp2p';
import type { MessageHandler, MessagePayload } from '@/types/poc/message';

type CheckForKeysNeedingRegeneratingVariant = Extract<
  MessageHandlerResult,
  { type: 'check-for-keys-needing-regenerating' }
>;

export const createCheckForKeysNeedingRegeneratingHandler = (
  loggerService: LoggerService
): MessageHandler<CheckForKeysNeedingRegeneratingVariant> => {
  const log = loggerService.createLogger({
    namespace: 'six3ro:p2p:handlers:check-for-keys-needing-regenerating',
  });

  return {
    canHandle: (_topic: string, message: MessagePayload): boolean =>
      message.type === 'check-for-keys-needing-regenerating',

    process: (
      message: MessagePayload,
      _libp2p: LibP2pWithServices,
      _heliaNode: HeliaNode | null
    ): CheckForKeysNeedingRegeneratingVariant => {
      if (message.type !== 'check-for-keys-needing-regenerating') {
        throw new Error(`Invalid message type: expected 'check-for-keys-needing-regenerating', got '${message.type}'`);
      }

      log.info(`Received check-for-keys-needing-regenerating for six ${message.sixId} from ${message.sender}`);

      return {
        type: 'check-for-keys-needing-regenerating',
        data: {
          sixId: message.sixId,
          sender: message.sender,
          messageTimestamp: message.timestamp,
        },
      };
    },
  };
};
